import { memo } from 'react';
import { XBoldIcon } from '@/icons';
import { imageDetailModal } from '@/shared/modals/ImageDetailModal';
import { useEditMode } from '../../focus/useIsEditMode';
import { QuizImage } from '../QuizImage';
export const MultipleOptionImage = memo(({
  imageUrl,
  isUploading,
  onRemove
}: {
  imageUrl: string;
  isUploading: boolean;
  onRemove?: () => void;
}) => {
  const {
    isEditMode
  } = useEditMode();
  if (isUploading) {
    return <Container>
          <QuizImage.Loading className="size-full" />
        </Container>;
  }
  return <Container>
        <QuizImage.Container className="size-full" onClick={() => {
      imageDetailModal.open(imageUrl);
    }}>
          <QuizImage.Thumbnail src={imageUrl} alt="multiple-option-image" />
        </QuizImage.Container>
        {isEditMode && onRemove && <QuizImage.RemoveButton className="shadow-xs" onClick={onRemove}>
            <XBoldIcon width={14} height={14} className="[&>*]:fill-white" />
          </QuizImage.RemoveButton>}
      </Container>;
});
const Container = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <div className="relative mb-sm ml-[39px] size-[62px]" data-sentry-component="Container" data-sentry-source-file="MultipleOptionImage.tsx">{children}</div>;
};